export default "__VITE_ASSET__CVEdAmOe__"